module.exports = __webpack_public_path__ + "static/publication-6ed708d038a811cbe5ab6cf49123c7f9.webm";